/* GC_AUTO_GIFT_START */
(function () {
  'use strict';

  var settings = {
    giftVariantId: 41156545085580,
    thresholdCents: 80000,
    busy: false,
    timer: null,
    internalRequest: false
  };

  function isCartMutation(url) {
    return typeof url === 'string' && /\/cart\/(add|change|update|clear)(\.js)?(?:\?|$)/.test(url);
  }

  function getGiftLine(cart) {
    return (cart.items || []).find(function (item) {
      return Number(item.variant_id) === settings.giftVariantId;
    });
  }

  function getQualifyingSubtotal(cart) {
    return (cart.items || []).reduce(function (subtotal, item) {
      if (Number(item.variant_id) === settings.giftVariantId) return subtotal;
      return subtotal + Number(item.final_line_price || item.line_price || 0);
    }, 0);
  }

  function request(url, options) {
    settings.internalRequest = true;
    return window.fetch(url, options).finally(function () {
      settings.internalRequest = false;
    });
  }

  function addGift() {
    return request('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        items: [{
          id: settings.giftVariantId,
          quantity: 1,
          properties: {
            '_Guerilla Choice Gift': 'The Signature Gift',
            '_Automatically Added': 'Yes'
          }
        }]
      })
    });
  }

  function changeGift(lineKey, quantity) {
    return request('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ id: lineKey, quantity: quantity })
    });
  }

  function refreshCart() {
    if (document.body.classList.contains('template-cart')) {
      window.location.reload();
      return;
    }

    document.dispatchEvent(new CustomEvent('cart:refresh', {
      detail: { open: false }
    }));
  }

  function syncGift() {
    if (settings.busy) return;
    settings.busy = true;

    request('/cart.js', {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        var gift = getGiftLine(cart);
        var qualifies = getQualifyingSubtotal(cart) >= settings.thresholdCents;

        if (qualifies && !gift) {
          return addGift().then(function () { return true; });
        }

        if (qualifies && gift && Number(gift.quantity) !== 1) {
          return changeGift(gift.key, 1).then(function () { return true; });
        }

        if (!qualifies && gift) {
          return changeGift(gift.key, 0).then(function () { return true; });
        }

        return false;
      })
      .then(function (changed) {
        if (changed) refreshCart();
      })
      .catch(function (error) {
        console.warn('Guerilla Choice auto-gift error:', error);
      })
      .finally(function () {
        settings.busy = false;
      });
  }

  function scheduleSync() {
    window.clearTimeout(settings.timer);
    settings.timer = window.setTimeout(syncGift, 300);
  }

  var originalFetch = window.fetch;
  window.fetch = function () {
    var input = arguments[0];
    var url = typeof input === 'string' ? input : (input && input.url);
    var promise = originalFetch.apply(this, arguments);

    if (!settings.internalRequest && isCartMutation(url)) {
      promise.finally(scheduleSync);
    }

    return promise;
  };

  var originalOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this._gcAutoGiftUrl = url;
    return originalOpen.apply(this, arguments);
  };

  var originalSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    this.addEventListener('loadend', function () {
      if (!settings.internalRequest && isCartMutation(this._gcAutoGiftUrl)) {
        scheduleSync();
      }
    });
    return originalSend.apply(this, arguments);
  };

  document.addEventListener('DOMContentLoaded', scheduleSync);
  document.addEventListener('page:loaded', scheduleSync);
  document.addEventListener('ajaxProduct:added', scheduleSync);
  document.addEventListener('cart:updated', scheduleSync);
})();
/* GC_AUTO_GIFT_END */